import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const StoryPreviewContext = React.createContext();

export function useStoryPreviewAuth() {
  return useContext(StoryPreviewContext);
}

export function StoryPreviewProvider({ children }) {
  const [storiesData, setStoriesData] = useState();
  const [storiesOpen, setOpenStories] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  function openStoryViewer(storiesArray) {
    setStoriesData(storiesArray);
    setOpenStories(true);
    setCurrentImage(0);
  }

  function closeStoryViewer() {
    setStoriesData([]);
    setOpenStories(false);
    setCurrentImage(0);
  }

  const value = useMemo(() => ({
    storiesData,
    storiesOpen,
    currentImage,
    openStoryViewer,
    closeStoryViewer
  }));
  return <StoryPreviewContext.Provider value={value}>{children}</StoryPreviewContext.Provider>;
}

StoryPreviewProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
